document.addEventListener('DOMContentLoaded', () => {
  function scrollToItem(carousel, itemIndex) {
    const targetItem = carousel.querySelectorAll('.custom-carousel-item')[itemIndex];
    const itemWidth = targetItem.offsetWidth + parseInt(window.getComputedStyle(targetItem).marginRight, 10);

    carousel.scrollTo({
      left: itemIndex * itemWidth,
      behavior: 'smooth',
    });
  }

  function updateProgressDot(carousel, itemIndex) {
    const dotsContainer = carousel.parentElement.querySelector('.custom-carousel-progress-dots');
    const dots = dotsContainer.querySelectorAll('.dot');

    for (const [index, dot] of dots.entries()) {
      dot.classList.toggle('active', index === itemIndex);
    }
  }

  function initializeCarousel(carouselWrapper) {
    const carousel = carouselWrapper.querySelector('.custom-carousel');
    const leftArrow = carouselWrapper.querySelector('.left-arrow');
    const rightArrow = carouselWrapper.querySelector('.right-arrow');
    const items = carousel.querySelectorAll('.custom-carousel-item');

    const scrollStep = items[0]?.offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight, 10) || 100;

    // Function to toggle arrow visibility
    function toggleArrows() {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      if (carousel.scrollLeft <= 0) {
        leftArrow.style.display = 'flex';
      } else {
        leftArrow.style.display = 'flex';
      }
      if (carousel.scrollLeft >= maxScroll) {
        rightArrow.style.display = 'flex';
      } else {
        rightArrow.style.display = 'flex';
      }
    }

    // Initial check
    toggleArrows();

    // Recheck on scroll
    carousel.addEventListener('scroll', toggleArrows);

    // Arrow click functionality
    leftArrow.addEventListener('click', () => {
      carousel.scrollBy({
        left: -scrollStep,
        behavior: 'smooth',
      });
    });

    rightArrow.addEventListener('click', () => {
      carousel.scrollBy({
        left: scrollStep,
        behavior: 'smooth',
      });
    });
  }

  const carouselWrappers = document.querySelectorAll('.carousel-wrapper');
  carouselWrappers.forEach(initializeCarousel);

  const carousels = document.querySelectorAll('.custom-carousel');

  for (const carousel of carousels) {
    const items = carousel.querySelectorAll('.custom-carousel-item');
    const dotsContainer = carousel.parentElement.querySelector('.custom-carousel-progress-dots');
    const dots = dotsContainer.querySelectorAll('.dot');

    for (const dot of dots) {
      dot.addEventListener('click', () => {
        const itemIndex = parseInt(dot.getAttribute('data-item-index'), 10);
        scrollToItem(carousel, itemIndex);
      });
    }

    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const itemWidth = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight, 10);
      const newIndex = Math.round(scrollLeft / itemWidth);

      const activeDot = dotsContainer.querySelector('.dot.active');
      const currentIndex = activeDot ? parseInt(activeDot.getAttribute('data-item-index'), 10) : -1;

      if (newIndex !== currentIndex) {
        updateProgressDot(carousel, newIndex);
      }
    });
  }
});
